export default "__VITE_ASSET__1f2b61c4__"